/* eslint-disable no-undef,guard-for-in,no-negated-condition */
import { SKIP_BASIC_AUTH_HEADER } from '../API/constants';

import Presence from './Presence';

/**
 *
 * @returns {*}
 */
export const getNextSchedule = () =>
    APP.WildixAPI.NextSchedule.get()
        .catch(error => {
            if (error.status === 404) {
                console.warn('No schedule found, returning an empty object.');

                return {};
            }
            throw error;
        });

/**
 *
 * @returns {Promise<any> | Promise}
 */
export const getPresence = () => new Promise((resolve, reject) => {
    APP.WildixAPI.UserPresence.get().then(data => {
        resolve(new Presence(
                data.result.show,
                data.result.status,
                data.result.until
        ));
    })
        .catch(message => {
            reject();
            console.log('User Presence error', message);
        });
});

/**
 *
 * @param presence
 * @returns {Promise<any> | Promise}
 */
export const setPresence = presence => {
    const url = `../api/v1/Personal/Presence?${SKIP_BASIC_AUTH_HEADER}`;
    const data = {
        status: presence.status,
        message: presence.message,
        until: presence.until,
        '_METHOD': 'PUT'
    };

    return new Promise((resolve, reject) => {
        if (navigator.sendBeacon !== undefined) {
            const form = new FormData();

            for (const p in data) {
                form.append(p, data[p] || '');
            }
            if (navigator.sendBeacon(url, form)) {
                resolve();
            } else {
                reject('Unable to send beacon');
            }
        } else {
            APP.WildixAPI.PersonalPresence.put(url, data).then(() => {
                resolve();
            })
            .catch(message => {
                reject(message);
            });
        }
    });
};
